import { Promo } from "../entities/promo-entity";
import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { Payment } from '../entities/payment';


export class PaymentRequestDto extends BaseRequest {
    payment : Payment;
}
